<script setup lang="ts"></script>

<template>
  <div class="container-root">
    <div class="main-container">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container-root {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  // トランジションが可視化されるように、コンテナ自体に背景色を設定します。
  background-color: v.$basic-white;
}

.main-container {
  position: relative;
  top: 0;
  width: 100%;
  flex-grow: 1; /* PageHeaderを除いた残りの高さをすべて埋める */
  max-width: v.$pc-max-page-width;
  min-height: 0; /* flexアイテムがコンテンツより小さくなれるようにする */
  margin: 0 auto;
  font-size: 1.6rem;
  box-sizing: border-box;
  min-width: 0; /* Flexアイテムがコンテンツの幅を超えても縮小できるようにする */
  display: flex; /* スロット内のコンポーネントに高さを渡すため */
  flex-direction: column;

  &:has(.login-page) {
    max-width: 100vw;
  }

  @include m.sp_mode {
    // margin: 0 auto v.$sp-footer-height;
    max-width: 100%; /* SPモードではPC用の最大幅を解除し、画面幅に合わせる */
    max-height: 100%;
    height: 100%;
  }
}
</style>
